import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { IApplicationState } from '../../Store';

import '../../App.css';

import { History } from 'history';
import { RouteComponentProps } from 'react-router-dom';
import {TableDashboard} from './TableDashboard';
import { IDashboardState, IFiltersDetail, IGroupList, monthsOfYear, percentHiddenColumns, randomImages } from '../../Store/Dashboard/Types';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { BiWindowClose } from "react-icons/bi";
import _ from 'lodash';

import { getDashboardDetail } from '../../Store/Dashboard/Actions';
import { TableDetails } from '../TableDetails';
import { ISearchState } from '../../Store/Search/Types';
import { IUserState } from '../../Store/User/Types';
import { Export } from './Export';
import { IExportFilters } from '../../Store/Export/Types';
import { hideDrawer } from '../../Store/Layout/Actions';
import { getExportDashboardPdf, getExportDashboardXls } from '../../Store/Export/Actions';

interface IPropsFromState {
  i18n: I18N;
  localeInfos: ILocaleInfos;
  router: RouteComponentProps<{}>;
  dashboard: IDashboardState;
  search : ISearchState;
  user: IUserState;
}

interface IPropsFromDispatch {
  getDashboardDetail: typeof getDashboardDetail
  hideDrawer: typeof hideDrawer
  getExportDashboardPdf: typeof getExportDashboardPdf
  getExportDashboardXls: typeof getExportDashboardXls
}

interface IState {
  columns: any;
  data: any;
  showDetails: boolean;
  resizeTable: boolean;
  showTableDetails: boolean;
  isRegime: boolean;
  showTitle: boolean;
  selectedDate: string;
  // medias
  mediasID: number[] | null;
  mediasStr: string[];
  isAllMediasSelected: boolean;
  // program types state
  programTypesID: number[] | null;
  programTypesStr: string[];
  isAllProgramTypesSelected: boolean;
  // program editors state
  programEditorsID: number[] | null;
  programEditorStr: string[];
  isAllProgramEditorsSelected: boolean;
  startDate: Date;
  endDate: Date;
  dateCloture: any;
  exportAnchor: HTMLElement | null;
  exportOpen: boolean;
  showDetailsList: number[]
}

interface IOwnProps {
  history: History;
}

type AllProps =
    MD.WithTheme &
    MD.WithStyles &
    IPropsFromState &
    IPropsFromDispatch&
    IOwnProps;

const styles = (theme:any) => MD.createStyles({
    tabs:{
      minHeight:'10px',
      position:'inherit',
      marginLeft:'20%'
    },
    tab:{
      minWidth:'10px',
      fontSize:'smaller',
      fontFamily:'sans-serif',
      textTransform:'initial',
      marginRight:'40px'
    },
    closeWindow: {
      position:'absolute',
      right: '20px',
      marginTop: '-20px',
      '&:hover': {
        color: 'red',
      }
    },
    ifilters:{
      fontSize: '14px',
      fontWeight: 500,
      backgroundColor: theme.palette.background.paper,
      display: 'inline-flex',
      padding: '10px 10px 5px',
      marginBottom: '10px',
      position: 'fixed',
      top: 40,
      left: 0,
      width: '100%',
      zIndex: 1200
    },
    topTableInfos: {
      display: 'inline-flex', padding: '10px', marginTop: 15
    },
    tableName: {
      display: 'inline-flex', color: theme.palette.primary.main, position: 'absolute', marginTop: '-20px'
    }
  }
)

const months = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
export type IElementType = {
  type: string | undefined,
  sum_duration: number,
  nb_broadcasts: number,
  nb_titles: number
}

export class DashboardContentComponent extends React.Component<AllProps, IState> {
  inputRef: React.RefObject<any>;
  
  public constructor(props: AllProps) {
      super(props);
      let endDate = new Date()
      this.inputRef = React.createRef();
      this.state = {
        columns: null,
        data: null,
        showDetails: false,
        resizeTable: false,
        showTableDetails: false,
        isRegime: false,
        showTitle: false,
        selectedDate: "",
        mediasID: null,
        mediasStr: [],
        isAllMediasSelected: true,
        programTypesID: null,
        programTypesStr: [],
        isAllProgramTypesSelected: true,
        programEditorsID: null,
        programEditorStr: [],
        isAllProgramEditorsSelected: true,
        startDate: new Date(endDate.getFullYear(), endDate.getMonth(), 1),
        endDate: endDate,
        exportAnchor: null,
        exportOpen: false,
        showDetailsList: [],
        dateCloture: null
      }
  }

  static getDerivedStateFromProps(props: AllProps, state: IState) {
    if (props.dashboard.isLoading) {
      state.showDetails = false
      state.showTableDetails = false
      state.showDetailsList = []
    }
    if (props.dashboard.dateCloture !== null && state.dateCloture === null) {
      let endDate = props.dashboard.dateCloture
      state.startDate = new Date(endDate.getFullYear(), endDate.getUTCMonth(), 1)
      state.endDate = endDate
      state.dateCloture = endDate
    }
    if (props.search.allProgramTypesID.length > 0 && state.programTypesID === null) {
      state.programTypesID = props.search.allProgramTypesID
      state.programTypesStr = props.search.allProgramTypesSTR
    }
    if (props.user.allMediasID.length > 0 && state.mediasID === null) {
        state.mediasID = props.user.allMediasID
        state.mediasStr = props.user.allMediasSTR
    }
    if (props.search.allProgramEditorsID !== null && state.programEditorsID === null) {
        state.programEditorsID = props.search.allProgramEditorsID
        state.programEditorStr = props.search.allProgramEditorsSTR
    }
    return state
  }
  
  componentDidUpdate(prevProps: AllProps, prevState:IState){
    if (!_.isEqual(prevProps.dashboard.filters.media_ids, this.props.dashboard.filters.media_ids)) {
      this.setState({
          mediasStr: this.props.dashboard.filters.media_str
      })
    }
    if (!_.isEqual(prevProps.dashboard.filters.program_type_ids, this.props.dashboard.filters.program_type_ids)) {
      this.setState({
          programTypesStr: this.props.dashboard.filters.program_type_str
      })
    }
    if (!_.isEqual(prevProps.dashboard.filters.date_start, this.props.dashboard.filters.date_start)) {
      this.setState({
          startDate: this.props.dashboard.filters.date_start
      })
    }
    if (!_.isEqual(prevProps.dashboard.filters.date_end, this.props.dashboard.filters.date_end)) {
      this.setState({
          endDate: this.props.dashboard.filters.date_end
      })
    }
    if ( !_.isEqual(this.state.columns, this.props.dashboard.columns) && this.props.dashboard.columns !== null &&
    this.props.dashboard.politicalGroupList.length > 0 ) {
      let columns = this.props.dashboard.columns
      
      columns.map((column) => {
        column.columns.map((x:any) => {
          if (x.accessor.indexOf("Libelle") > -1) {
            column.Header = this.buildMediasLogos(this.props.dashboard.filters.media_ids)
          }
          if (typeof(x.accessor) === "string" && x.accessor.indexOf("Cumuls") > -1) {
            x.Header = (
              <div>
                <span>Cumuls</span>
                { column.columns.length > 1 &&
                <span onClick={() => this.toggleColumn(column) }>
                  { column.columns[0].show ? 
                    <span style={{paddingLeft:'10px'}}> <RemoveIcon style={{marginBottom:'-5px', fontSize: 15, cursor: 'pointer'}} /> </span> : 
                    <span style={{paddingLeft:'10px'}}> <AddIcon style={{marginBottom:'-5px', fontSize: 15, cursor: 'pointer'}} /> </span>
                  }
                </span>
                }
              </div>
            ) 
          }
          return columns
        })
        return columns
      })
      this.setState({ columns: columns})
    }
    if (!_.isEqual(prevProps.dashboard.filters.display_format, this.props.dashboard.filters.display_format) && this.state.columns !== null) {
      if (this.props.dashboard.filters.display_format === 'percent') {
        let columns:any = [...this.state.columns]
        percentHiddenColumns.map(x => {
          columns = columns.filter((column:any) => column.cid !== x )
          return columns
        })
        this.setState({ columns: columns})
      }
    }
  }

  componentDidMount(){
  }

  private buildMediasLogos(media_ids:number[]) {
    return (
      <div
        style={{
          display: "inline-flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          alignItems: "baseline",
        }}
      >
        {media_ids.map((id) => {
          return (
            <img
              key={id}
              style={{ paddingRight: "5px" }}
              height={30}
              src={randomImages[id]}
              alt={""}
            />
          );
        })}
      </div>
    );
  }

  private toggleColumn = (col:IGroupList) => {
    let columnsCopy = [...this.state.columns]
    let showDetailsListCopy = [...this.state.showDetailsList]
    let show = false
    columnsCopy = columnsCopy.map(column => {
      if (typeof(col.id) === 'number' && col.id === column.id && col.columns.length > 1) {
        col.columns.map((x:any) => {
          if (typeof(x.accessor) === "string" && x.accessor.indexOf("Cumuls") < 0) {
            x.show = !x.show
            show = x.show
          }
          if (typeof(x.accessor) === "string" && x.accessor.indexOf("Cumuls") > -1) {
            x.Header = (
              <div>
                <span>Cumuls</span>
                <span onClick={() => this.toggleColumn(column) }>
                  { show ? 
                    <span style={{paddingLeft:'10px'}}> <RemoveIcon style={{marginBottom:'-5px', fontSize: 15, cursor: 'pointer'}} /> </span> : 
                    <span style={{paddingLeft:'10px'}}> <AddIcon style={{marginBottom:'-5px', fontSize: 15, cursor: 'pointer'}} /> </span>
                  }
                </span>
              </div>
            ) 
          }
          return x
        })
      }
      return column
    })
    if (col.cid !== undefined) {
      if (showDetailsListCopy.some(x => x === col.cid)) {
        showDetailsListCopy = showDetailsListCopy.filter(x => x!== col.cid)
      } else {
        showDetailsListCopy.push(col.cid)
      }
    }
    
    this.setState({ 
      columns: columnsCopy,
      showDetailsList: showDetailsListCopy,
      resizeTable: columnsCopy.some(x => x.columns && x.columns.length > 1 && x.columns[0].show === true)
    })
  }

  private handleShowDetails() {
    let columnsCopy = [...this.state.columns]
    columnsCopy = columnsCopy.map(column => {
        column.columns.map((x:any) => {
          if (typeof(x.accessor) === "string" && x.accessor.indexOf("Cumuls") < 0 && x.accessor !== "Libelle" && x.accessor !== "Total" && column.columns.length > 1) {
            x.show = !this.state.showDetails
          } 
          if (typeof(x.accessor) === "string" && x.accessor.indexOf("Cumuls") > -1) {
            x.Header = (
              <div>
                <span>Cumuls</span>
                { column.columns.length > 1 &&
                <span onClick={() => this.toggleColumn(column) }>
                  { !this.state.showDetails ? 
                    <span style={{paddingLeft:'10px'}}> <RemoveIcon style={{marginBottom:'-5px', fontSize: 15, cursor: 'pointer'}} /> </span> : 
                    <span style={{paddingLeft:'10px'}}> <AddIcon style={{marginBottom:'-5px', fontSize: 15, cursor: 'pointer'}} /> </span>
                  }
                </span>
                }
              </div>
            ) 
          }
          return x
        })
      return column
    })

    let ids:number[] = []
    if (!this.state.showDetails) {
      columnsCopy.map((x:any) => {
        if (x.cid !== undefined) {
          ids.push(x.cid)
        }
        return ids
      })
    }
    this.setState({ 
      columns: columnsCopy,
      showDetails: !this.state.showDetails,
      showDetailsList: ids,
      resizeTable: !this.state.showDetails
    })
  }

  private getDateFromMonthYear(input:string) {
    const parts = input.split(" ");
    const [day, searchMonth, year] = parts;
    if (searchMonth !== undefined) {
      const month = months.indexOf(searchMonth.toLowerCase());
      if (month < 0) {
        //throw Error(`Unknown month: "${searchMonth}"`);
        return null
      } else return new Date(parseInt(year), month, parseInt(day));
    } else return null
  }

  private getDatesFromMonth(month: string) {
    const monthNumber = monthsOfYear.findIndex((x:string) => x === month)
    if (monthNumber > -1) {
      return [new Date(this.props.dashboard.filters.date_start.getFullYear(), monthNumber, 1),
        new Date(this.props.dashboard.filters.date_start.getFullYear(), monthNumber + 1, 1)]
    } else return null
  }

  private rowClick: any = (state: any, rowInfo: any | undefined, column: any) => {
    const { dashboard } = this.props;
    let columnsCopy = [...this.state.columns]
    let showTable: boolean = false
    let isRegime:boolean = false
    let showTitle:boolean = true
    if (rowInfo) {
          showTable = true
          let disableClick:boolean = false
          let regime_ids:number[] = [], group_ids:number[] = []
          let id:any = column.id
          if (typeof(id) === "string") {
            if (id.indexOf("Cumuls") > -1) {
              isRegime = true
              if (column.parent.cid !== undefined) {
                regime_ids.push(column.parent.cid)
              }
            } else if (id.indexOf("Total") > -1 || id.indexOf("Libelle") > -1) {
              showTitle = false
              columnsCopy.map(column => {
                if (column.cid !== undefined) {
                  regime_ids.push(column.cid)
                }
                return regime_ids
              })
            } else {
              showTable = false
              showTitle = false
            }
          } 
          if (typeof(column.cid) === "number") {
            group_ids.push(column.cid)
            showTable = true
            showTitle = true
            if (rowInfo.original[column.id] === '--') {
              disableClick = true
              showTable = false
              showTitle = false
            }
          }
          let date:any = null
          let endDate:any = null
          if (dashboard.filters.date_type === 'month' || dashboard.filters.date_type === 'calendar') {
            if (rowInfo.original.Libelle === 'Total') {
              date = dashboard.filters.date_start
              endDate = dashboard.filters.date_end
            }  else {
              date =  this.getDateFromMonthYear(rowInfo.original.Libelle)
              if (date !== null) {
                endDate = new Date(new Date(date).setDate(new Date(date).getDate() + 1))
              }
            }
            
            
          } else {
            let dates = this.getDatesFromMonth(rowInfo.original.Libelle)
            date = dates !== null ? dates[0] : null
            endDate = dates !== null ? dates[1] : null
          }
          if (date !== null && endDate !== null && !disableClick) {
            endDate.setHours(0)
            endDate.setMinutes(0)
            endDate.setSeconds(0)
            endDate.setMilliseconds(0)
            showTable && this.props.getDashboardDetail({
              political_regime_ids: regime_ids,
              political_group_ids: group_ids,
              media_ids: dashboard.filters.media_ids,
              program_type_ids: dashboard.filters.program_type_ids,
              program_editor_ids: dashboard.filters.program_editors_ids,
              time_slot_start: dashboard.filters.time_slot_start,
              time_slot_end: dashboard.filters.time_slot_end,
              date_start: new Date(date),
              date_end: endDate,
              study_type_id: 24,
              program_name: dashboard.filters.program_name
            })
            this.setState({ 
              showTableDetails: showTable,
              selectedDate: rowInfo.original.Libelle,
              isRegime: isRegime,
              showTitle: showTitle
            })  
          }
      this.props.hideDrawer()
    }
    return {}
  }

  private buildDetailsTable() {
    const { classes, i18n } = this.props;
    return (
      this.props.dashboard.isLoadingDetail ? 
        <div>
          {i18n._('Loading')}..
        </div> 
      : this.props.dashboard.dashboardDetail === null ?
        <div>
          {i18n._('No results')}
        </div> 
      :
      <>
        <div id='top-table-infos' className={classes.topTableInfos}>
          <span id="table-name" className={classes.tableName}>
            {
              this.state.showTitle &&
              this.state.isRegime &&
              this.props.dashboard.dashboardDetail[0] !== undefined &&
              <span>
                {this.props.dashboard.dashboardDetail[0].political_regime_name} -&nbsp;
              </span>
            }
            {
              this.state.showTitle &&
              !this.state.isRegime &&
              this.props.dashboard.dashboardDetail[0] !== undefined &&
              <span>
                {this.props.dashboard.dashboardDetail[0].political_group_name} -&nbsp;
              </span>
            }
            {this.state.selectedDate}
          </span>
          <MD.IconButton
            className={classes.closeWindow}
            onClick={() => this.setState({
              showTableDetails: false,
              showTitle: false
            })}
            >
              <BiWindowClose title={i18n._('Close')} />
          </MD.IconButton>
        </div>
        <TableDetails
        data={this.props.dashboard.dashboardDetail}
        type={'dashboard'}
        />
      </>
    )
  }
  
  private buildExport() {
    const { dashboard } = this.props;
    let filters:IExportFilters = {
      media_ids: dashboard.filters.media_ids,
      program_type_ids: dashboard.filters.program_type_ids,
      program_editor_ids: dashboard.filters.program_editors_ids,
      date_type: dashboard.filters.date_type,
      display: dashboard.filters.display_format,
      date_start: dashboard.filters.date_start,
      date_end: dashboard.filters.date_end,
      time_slot_start: dashboard.filters.time_slot_start,
      time_slot_end: dashboard.filters.time_slot_end,
      show_detail_list: this.state.showDetailsList,
      program_name: dashboard.filters.program_name,
    } 
    return (
      <div style={{position: 'absolute', right: '15px', display: 'inline-flex'}}>
          <Export exportAction={this.props.getExportDashboardPdf} filters={filters} exportType = 'pdf' />
          <Export exportAction={this.props.getExportDashboardXls} filters={filters} exportType = 'xls' />
      </div>
  )}
  public render(): React.ReactNode {  
    const { i18n, theme } = this.props;
    if (this.props.dashboard.isLoading || this.props.dashboard.politicalGroupList.length === 0) {
      return (
        <div style={{ paddingTop: 30 }}>
          {i18n._('Loading')}..
        </div>
      )
    } else if (this.props.dashboard.dataHms.length === 0 || (
      this.props.dashboard.dashboardResults !== null && this.props.dashboard.dashboardResults.totals.total_duration.milliseconds === 0)) 
      {
        return (
          <div style={{ paddingTop: 30 }}>
            {i18n._('No results')}
          </div>
        )
      }
    else if (this.state.columns !== null && this.props.dashboard.politicalGroupList.length > 0) {
      return (
        <div style={{ paddingTop: 30 }}>
          { ! this.state.showTableDetails ? 
            <>
              <div id="actions-bar" style={{display: 'inline-flex'}}>
                <div id="showDetails" style={{display: 'inline-flex'}}>
                  <MD.Checkbox
                  style={{color: this.state.showDetails ? theme.palette.primary.main : theme.palette.primary.light }}
                  value={this.state.showDetails}
                  checked={this.state.showDetails}
                  onClick= { ()=> this.handleShowDetails() }
                  />
                  <MD.ListItemText primary={"Afficher le détail"} style={{padding: '5px'}}/>
                </div>
                {
                  this.buildExport()
                }
              </div>
              <TableDashboard
                resizeTable={this.state.resizeTable}
                data={this.props.dashboard.filters.display_format === 'duration' ? this.props.dashboard.dataHms : this.props.dashboard.dataPercent} 
                columns={this.state.columns}
                rowClick={this.rowClick.bind(this)}
              />
            </>
            :
            this.buildDetailsTable()
          }
        </div>
      )
    } else {
      return null
    }
  }

}

const mapStateToProps = ({i18n, dashboard, search, user} : IApplicationState, ownProps: RouteComponentProps<{}>) => {
  return {
    i18n: i18n.i18n,
    localeInfos: i18n.localeInfos,
    router: ownProps,
    dashboard,
    search,
    user
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getDashboardDetail: (filters: IFiltersDetail) => dispatch(getDashboardDetail(filters)),
  hideDrawer : () => dispatch(hideDrawer()),
  getExportDashboardPdf: (filters: any) => dispatch(getExportDashboardPdf(filters)),
  getExportDashboardXls: (filters: any) => dispatch(getExportDashboardXls(filters)),
});


export const DashboardContent = 
    connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(DashboardContentComponent)));
